export default "__VITE_ASSET__CYgjiGHT__"